export default __webpack_public_path__ + "static/media/CoverImage.6969b071.png";